/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $FantaConfig = {
    properties: {
        maxPlayers: {
            type: 'PlayerCountConfig',
        },
        amountPlayersLineup: {
            type: 'PlayerCountConfig',
        },
        maxTransfer: {
            type: 'PlayerCountConfig',
        },
        transferStart: {
            type: 'string',
            format: 'date',
        },
        transferStop: {
            type: 'string',
            format: 'date',
        },
        availableBoosters: {
            type: 'BoosterCountConfig',
        },
    },
} as const;
